import style from "./EmploymentDetails.module.css";
import { RootState } from "@/store/dtm";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AssetsDetails(props: any) {
    const navigate = useNavigate();
    const assets = useSelector((state: RootState) => state.assets.assets);
    const [assetsList, setAssetsList] = useState<any[]>([]);
    const [totalAssetsValue, setTotalAssetsValue] = useState(0);
    const [downpaymentList, setDownpaymentList] = useState<any[]>([]);
    const [totalDownpaymentValue, setTotalDownpaymentValue] = useState(0);

    useEffect(() => {

        let mainList: any[] = [];
        let secondaryList: any[] = [];
        assets.forEach((asset) => {

            if (asset.assetCategory === "nonregistered") {
                let subtitle = "";
                switch (asset.assetType) {
                    case "chequingaccount":
                        subtitle = "Chequing Account";
                        break;
                    case "savingsaccount":
                        subtitle = "Savings Account";
                        break;
                    case "termgic":
                        subtitle = "Term/GIC";
                        break;
                    case "sharesstocks":
                        subtitle = "Shares/Stocks";
                        break;
                    case "mutualfunds":
                        subtitle = "Mutual Funds";
                        break;
                }
                mainList.push({
                    title: "Non-Registered",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalAssetsValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "registered") {
                let subtitle = "";
                switch (asset.assetType) {
                    case "rrsp":
                        subtitle = "RRSP";
                        break;
                    case "resp":
                        subtitle = "RESP";
                        break;
                    case "rrifliflira":
                        subtitle = "RRIF/LIF/LIRA";
                        break;
                    case "tfsa":
                        subtitle = "TFSA";
                        break;
                    case "other":
                        subtitle = "Other";
                        break;
                    case "fhsa":
                        subtitle = "FHSA";
                        break;
                }
                mainList.push({
                    title: "Registered",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                })
                setTotalAssetsValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "realestate") {
                let subtitle = 
                (asset.details?.realEstate?.address?.unitNumber ? asset.details?.realEstate?.address?.unitNumber + "-" : "")
                + asset.details?.realEstate?.address?.streetNumber 
                + " " + asset.details?.realEstate?.address?.streetName 
                + " " + asset.details?.realEstate?.address?.streetType
                + " " + asset.details?.realEstate?.address?.streetDirection
                + ", " + asset.details?.realEstate?.address?.city
                + ", " + asset.details?.realEstate?.address?.province
                + ", " + asset.details?.realEstate?.address?.postalCode
                + ", " + asset.details?.realEstate?.address?.country
                mainList.push({
                    title: "Real Estate",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalAssetsValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "vehicle") {
                let subtitle = asset.details?.vehicle?.year
                    + " " + asset.details?.vehicle?.make
                    + " " + asset.details?.vehicle?.model;
                mainList.push({
                    title: "Vehicle",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalAssetsValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "lifeinsurance"){
                let subtitle = asset.description || "Life Insurance";
                mainList.push({
                    title: "Life Insurance",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalAssetsValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "other") {
                let subtitle = asset.description || "Other";
                mainList.push({
                    title: "Other",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalAssetsValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "gift"){
                let subtitle = asset.description || "Gift";
                secondaryList.push({
                    title: "Gift",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalDownpaymentValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "depositonpurchase") {
                let subtitle = asset.description || "Deposit on Purchase";
                secondaryList.push({
                    title: "Deposit on Purchase",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalDownpaymentValue((prev) => prev + asset.value);
            } else if (asset.assetCategory === "builderdeposit"){
                let subtitle = asset.description || "Builder Deposit";
                secondaryList.push({
                    title: "Builder Deposit",
                    subtitle: subtitle,
                    value: (<span>{asset.value.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                });
                setTotalDownpaymentValue((prev) => prev + asset.value);
            }
        });
        setAssetsList(mainList);
        setDownpaymentList(secondaryList);

    }, [assets]);

    return (
        <div className="mt-5">
            <div className="flex flex-row justify-between mt-5">
                <h2>Assets & additional down payment sources</h2>
                <h3
                    className="brand-blue-text text-xs grid grid-flow-col cursor-pointer"
                    onClick={() => {
                        navigate("/single/assets", { state: { editMode: true } });
                    }}
                >
                    <img
                        src="assets/edit-icon.svg"
                        className={style.editIcon}
                        alt="edit"
                    />
                    <span>Edit</span>
                </h3>
            </div>
            {assetsList.length > 0 &&
            <div className="mt-5">
                <h4>Assets</h4>
                <table style={{ width: "100%", marginTop: "1rem", borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th style={{ background: "#E6EDF0", textAlign: "left", padding: "8px" }}>Description</th>
                            <th style={{ background: "#E6EDF0", textAlign: "right", padding: "8px" }}>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assetsList.map((asset, index) => (
                            <tr key={index}>
                                <td style={{ padding: "8px" }}>
                                    <div>{asset.title}</div>
                                    <div style={{ fontSize: "0.9em", color: "#555" }}>{asset.subtitle}</div>
                                </td>
                                <td style={{ padding: "8px", textAlign: "right" }}>{asset.value}</td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ background: "#E6EDF0", padding: "8px", fontWeight: "bold" }}>Total Assets</td>
                            <td style={{ background: "#E6EDF0", padding: "8px", textAlign: "right", fontWeight: "bold" }}>
                                {totalAssetsValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            }

            {downpaymentList.length > 0 &&
            <div className="mt-5">
                <h4>Down Payment Sources</h4>
                <table style={{ width: "100%", marginTop: "1rem", borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th style={{ background: "#E6EDF0", textAlign: "left", padding: "8px" }}>Description</th>
                            <th style={{ background: "#E6EDF0", textAlign: "right", padding: "8px" }}>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {downpaymentList.map((asset, index) => (
                            <tr key={index}>
                                <td style={{ padding: "8px" }}>
                                    <div style={{ fontSize: "0.9em", color: "#555" }}>{asset.title}</div>
                                </td>
                                <td style={{ padding: "8px", textAlign: "right" }}>{asset.value}</td>
                            </tr>
                        ))}
                        <tr>
                            <td style={{ background: "#E6EDF0", padding: "8px", fontWeight: "bold" }}>Total Contributions</td>
                            <td style={{ background: "#E6EDF0", padding: "8px", textAlign: "right", fontWeight: "bold" }}>
                                {totalDownpaymentValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>}

        </div>
    );
}